@let withCallWaiterMain = this.withCallWaiterMain();
@let withCallWaiterRequestBill = this.withCallWaiterRequestBill();

<app-page-header
  class="header"
  [backSwipe]="backSwipeConfig"
  [tableName]="table()?.tableName"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <div class="title">
    <img
      class="logo"
      height="80"
      width="250"
      src="/images/logo.svg"
      alt="Sunset Grill logo"
    >
    <span class="text">Service Centre</span>
  </div>


  <div class="call__buttons">

    @if (withCallWaiterMain) {
      <app-button-call-waiter-main
        class="call-waiter"
        coreActivitySection="CallWaiter"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('main', callWaiterMain())"
      />
    }

    @if (withCallWaiterRequestBill) {
      <app-button-call-waiter-bill
        class="call-waiter"
        coreActivitySection="CallWaiter"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('secondary', collWaiterRequestBill())"
      />
    }

  </div>

  <app-service-center-amenities class="amenities"/>
</div>

